<template>
  <div>
    <Navbar />
    <router-view class="main_content"></router-view>
  </div>
</template>

<style></style>
<script>
import Navbar from "../components/Navbar-user.vue";
export default {
  name: "UserRouter",
  components: {
    Navbar,
  },
};
</script>
